<template>
  <div class="home">
    <section class="cards">
      <div class="video-container">
        <video
          playsinline
          autoplay
          muted
          loop
          poster="@/assets/Demo_Reel_02_First_Frame.jpg"
        >
          <source
            :src="require('@/assets/Demo_Reel_02.mp4')"
            type="video/mp4"
          />
        </video>
      </div>
      <div class="services-container">
        <h5>Services</h5>
        <div class="single-services-box">
          <div class="single-service-box-grid">
            <div class="single-service">
              <clipboard-icon size="3x"></clipboard-icon>
              <h6>Producing</h6>
            </div>
            <div class="single-service">
              <video-icon size="3x"></video-icon>
              <h6>Directing</h6>
            </div>
            <div class="single-service">
              <scissors-icon size="3x"></scissors-icon>
              <h6>Editing</h6>
            </div>
          </div>
        </div>
        <p>
          Social content — News and Documentary — Branded & Commercial
        </p>
        <!-- <div>
          <img
            src="@/assets/signe_on_set.png"
            alt="Signe Profile Picture in Black and White"
            style="height: 400px;"
          />
        </div> -->
      </div>
      <div class="my-work-container">
        <div class="my-work">
          <h6>GET A TASTE OF</h6>
          <h5>MY WORK:</h5>
          <ul>
            <li><router-link to="/social">News & Social Media</router-link></li>
            <li>
              <router-link to="/branded">Commercial & Branded</router-link>
            </li>
          </ul>
        </div>
      </div>
      <div class="whoami-container">
        <h6>
          <span>“</span>With a background in journalism,
          <strong>storytelling is everything to me.</strong>
        </h6>
        <p>
          I create videos that get your audience’s attention and make your brand
          stand out.
        </p>
        <router-link to="/about">Read more</router-link>
      </div>
      <div class="profile-container">
        <img
          src="@/assets/signe_black_and_white.jpg"
          alt="Signe Profile Picture in Black and White"
        />
      </div>
      <div class="lets-talk-container">
        <p>I am always interested in cool stuff.</p>
        <p>Do you have a project in mind?</p>
        <h6>LET’S CHAT.</h6>
        <ts-button
          title="CONTACT ME"
          style="margin-top: 0"
          @click="$router.push('/contact')"
        />
      </div>
    </section>
  </div>
</template>

<script>
import { ScissorsIcon } from "vue-feather-icons";
import { VideoIcon } from "vue-feather-icons";
import { ClipboardIcon } from "vue-feather-icons";
import TSButton from "@/components/TSButton";

export default {
  name: "Home",
  components: {
    ScissorsIcon,
    VideoIcon,
    ClipboardIcon,
    "ts-button": TSButton,
  },
};
</script>

<style lang="scss" scoped>
@import "src/theme.scss";

.home {
  min-height: 80vh;
  display: grid;
  grid-template-columns: 1fr repeat(12, auto) 1fr;
  grid-gap: 40px;
}
.cards {
  grid-column: 2 / span 12;
  display: grid;
  grid-template-columns: repeat(12, 1fr);
  grid-gap: 40px;
}
.video-container {
  grid-column: 2 / span 10;
}
.video-container video {
  width: 100%;
}
.services-container {
  grid-row: 2;
  grid-column: 2 / span 10;
  margin-top: 64px;
}
.services-container h5 {
  font-size: 48px;
  font-weight: 900;
  text-transform: uppercase;
  margin: 0;
}
.services-container h6 {
  font-size: 24px;
}
.services-container p {
  text-align: center;
  margin: 72px 0 0 0;
}
.single-services-box {
  display: grid;
  grid-template-columns: 1fr 1fr 1fr 1fr 1fr;
  grid-gap: 40px;
  margin-top: 64px;
}
.single-service-box-grid {
  grid-column: 2 / span 3;
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  grid-gap: 10px;
}
.single-service {
  min-width: 140px;
  grid-column: span 1;
}
.single-service h6 {
  font-size: 18px;
  font-weight: 500;
  margin: 8px 0 0 0;
}
.my-work-container {
  grid-row: 3;
  grid-column: 4 / span 6;
  margin-top: 64px;
}
.my-work {
  background-color: #f2e9e4;
  padding: 24px 48px;
}
.my-work h6 {
  text-transform: uppercase;
  font-size: 48px;
  font-weight: 900;
  margin: 32px 0 0 0;
}
.my-work h5 {
  text-transform: uppercase;
  font-size: 48px;
  font-weight: 900;
  margin: -15px 0 0 0;
  color: #9a8c98;
}
.my-work ul {
  list-style: none;
  padding: 0;
  margin-top: 32px;
}
.my-work li {
  margin-bottom: 6px;
}
.my-work a {
  text-decoration: none;
  text-transform: uppercase;
  color: $black-color;
}
.my-work a:hover {
  color: #9a8c98;
}
.whoami-container {
  grid-row: 4;
  grid-column: 4 / span 3;
  text-align: left;
  margin-top: 164px;
}
.whoami-container span {
  color: $grey-500;
  line-height: 0.5;
  font-size: 72px;
}
.whoami-container h6 {
  margin-top: 4px;
  font-size: 18px;
  font-weight: 400;
  margin-bottom: 0;
}
.whoami-container p {
  margin-top: 16px;
}
.whoami-container a {
  text-decoration: none;
  font-style: italic;
  font-size: 14px;
  color: $grey-500;
}
.whoami-container a:hover {
  color: $black-color;
}
.profile-container {
  grid-row: 4;
  grid-column: 7 / span 4;
  margin-top: 64px;
}
.profile-container img {
  max-height: 400px;
}
.lets-talk-container {
  grid-row: 5;
  grid-column: 1 / span 12;
  margin-top: 100px;
  margin-bottom: 100px;
}
.lets-talk-container p {
  margin: 0;
}
.lets-talk-container h6 {
  text-transform: uppercase;
  font-size: 64px;
  font-weight: 900;
  margin: 18px 0 18px 0;
}
.lets-talk-container a {
  text-decoration: none;
  color: $black-color;
  margin: -10px;
  display: block;
}
@media only screen and (max-width: 1075px) {
  .home {
    grid-template-columns: 40px repeat(12, 1fr) 40px;
    grid-gap: 10px;
  }
  .cards {
    grid-column: 2 / span 12;
    display: grid;
    grid-template-columns: repeat(12, 1fr);
    grid-gap: 10px;
  }
  .video-container {
    grid-column: 1 / span 12;
    margin-top: 40px;
  }
  .single-services-box {
    display: grid;
    grid-template-columns: 1fr 1fr 1fr;
    grid-gap: 40px;
    margin-top: 64px;
  }
  .single-service-box-grid {
    grid-column: 1 / span 3;
    display: grid;
    grid-template-columns: 1fr 1fr 1fr;
    grid-gap: 40px;
  }
  .my-work-container {
    grid-row: 3;
    grid-column: 1 / span 12;
  }
  .whoami-container {
    grid-row: 4;
    grid-column: 2 / span 5;
  }
  .profile-container {
    grid-row: 4;
    grid-column: 8 / span 4;
  }
}
@media only screen and (max-width: 700px) {
  .home {
    grid-template-columns: 40px repeat(12, 1fr) 40px;
    grid-gap: 10px;
  }
  .cards {
    grid-column: 2 / span 12;
    display: grid;
    grid-template-columns: repeat(12, 1fr);
    grid-gap: 10px;
  }
  .video-container {
    grid-column: 1 / span 12;
    margin-top: 40px;
  }
  .services-container {
    grid-row: 2;
    grid-column: 1 / span 12;
    margin-top: 64px;
  }
  .single-services-box {
    display: grid;
    grid-template-columns: 1fr 1fr 1fr;
    grid-gap: 10px;
    margin-top: 64px;
  }
  .single-service-box-grid {
    grid-column: 1 / span 3;
    display: grid;
    grid-template-columns: 1fr 1fr 1fr;
    grid-gap: 10px;
  }
  .my-work-container {
    grid-row: 3;
    grid-column: 1 / span 12;
  }
  .whoami-container {
    grid-row: 4;
    grid-column: 2 / span 10;
  }
  .profile-container {
    grid-row: 5;
    grid-column: 2 / span 10;
  }
  .lets-talk-container {
    grid-row: 6;
    grid-column: 2 / span 10;
  }
}

@media only screen and (max-width: 550px) {
  .home {
    grid-template-columns: 10px repeat(12, 1fr) 10px;
    grid-gap: 10px;
  }
  .cards {
    grid-column: 2 / span 12;
    display: grid;
    grid-template-columns: repeat(12, 1fr);
    grid-gap: 10px;
  }
  .video-container {
    grid-column: 1 / span 12;
    margin-top: 40px;
  }
  .services-container {
    grid-row: 2;
    grid-column: span 14;
    margin-top: 64px;
  }
  .single-services-box {
    grid-template-columns: 1fr;
    grid-gap: 5px;
  }
  .single-service-box-grid {
    grid-column: 1 / span 1;
    display: grid;
    grid-template-columns: 1fr;
    grid-gap: 10px;
  }
  .single-service {
    margin-top: 40px;
  }
}
</style>
